import React, { useEffect, useMemo } from 'react';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import img7 from '../../../assets/img/jobs/slider8.jpg';
import img1 from '../../../assets/img/jobs/slider1.jpg';
import img2 from '../../../assets/img/jobs/ticker2.jpg';
import img3 from '../../../assets/img/jobs/ticker3.jpg';
import img4 from '../../../assets/img/jobs/ticker4.jpg';
import img5 from '../../../assets/img/jobs/ticker5.jpg';
import img6 from '../../../assets/img/jobs/ticker1.jpg';
import img8 from '../../../assets/img/jobs/slider4.jpg';
import img9 from '../../../assets/img/jobs/slider5.jpg';
import img10 from '../../../assets/img/jobs/slider6.jpg';
import img11 from '../../../assets/img/jobs/slider7.jpg';

import './TeamSlider.scss';
import TeamSlideItem from './TeamSlideItem';
import useResizeWindows from '../../../utils/hooks/useResizeWindow';



const TeamSlider = () => {
  const windowWidth = useResizeWindows();

  let allBig = windowWidth <= 376 ? true : false;
  const imagesArr = useMemo(() => 
    [ img2, img1, img3, img4, img5, img6, img7, img8, img9, img10, img11 ]
  , []);

  const getImagesForSlider = (arr) => {
    const newArr = [];
    let currentArr = []

    arr.forEach((img, index) => {
      if (index === 0) { //first slide (big)
        newArr.push([img]);
      } 
      else {
        currentArr.push(img);
        if (currentArr.length === 4) { //добавляем новую стопку
          newArr.push(currentArr)
          currentArr = [];
        }
      }
    });

    if (currentArr.length > 0) {
      if (currentArr.length < 4) {
        let i = 1; // start from 1 to skip the big image
        while (currentArr.length < 4) {
          currentArr.push(arr[i]);
          i++;
          if (i >= arr.length) i = 1;
        }
      }
      newArr.push(currentArr);
    }

    return newArr;
  }

  const sliderImages = useMemo(() => {
    if (windowWidth <= 376) {
      return imagesArr;
    }
    const res = getImagesForSlider(imagesArr);
    return res;
  }, [windowWidth]);

  useEffect(() => {
    const swiper = new Swiper('.swiper-job3', { //тот же класс, что и в разметке
      loop: true,    
      pagination: {
        el: '.swiper-pagination-job3',
      },
      breakpoints: {
        2500: {
          spaceBetween: 17.78,
          slidesPerView: 2,
        },
        2259: {
          spaceBetween: 15,
          slidesPerView: 2,
        },
        600:{
          slidesPerView: 2, 
          spaceBetween: 10,
        },
        376: { 
          slidesPerView: 1.5, 
          spaceBetween: 10,
        },
        0: { 
          spaceBetween: 16,
          slidesPerView: 1.5, 
        }
      },
      navigation: {
        nextEl: '.swiper-button-next-job3',
        prevEl: '.swiper-button-prev-job3',
      },
    });

    return () => {
      swiper.destroy(); // Очистка при размонтировании
    };
  }, []);

  return (
    <div className="swiper-wrapper-job3">

      <div className="swiper-job3">
        <div className="swiper-wrapper">
          {sliderImages?.map((imgArr, index) => {
            return (
              <div className="swiper-slide" key={`slide-${index}`}>
                <TeamSlideItem images={imgArr} id={index} allBig={allBig}/>
              </div>
            )
          })}
        </div>
      </div>

      <div className="swiper-button-prev-job3"></div>
      <div className="swiper-button-next-job3"></div>
    </div>
  );
};

export default TeamSlider;